/**
 * Process items with concurrency limit using native JavaScript
 * @param {Array} items - Array of items to process
 * @param {number} concurrencyLimit - Maximum number of concurrent operations
 * @param {Function} processItem - Async function to process each item
 * @returns {Promise<Array>} - Array of results
 */
export const processWithConcurrency = async (items, concurrencyLimit, processItem) => {
  const results = [];
  const chunks = [];

  // Split items into chunks based on concurrency limit
  for (let i = 0; i < items.length; i += concurrencyLimit) {
    chunks.push(items.slice(i, i + concurrencyLimit));
  }

  // Process chunks sequentially, but items within each chunk concurrently
  for (const chunk of chunks) {
    const chunkPromises = chunk.map(processItem);
    const chunkResults = await Promise.all(chunkPromises);
    results.push(...chunkResults.filter(result => result !== undefined));
  }

  return results;
};
